export let ProductType;

(function (ProductType) {
  ProductType["VHIS"] = "vhis";
  ProductType["ACCIDENTAL_MEDICAL"] = "accidental-medical";
  ProductType["MEDICAL"] = "medical";
  ProductType["MEDICAL_RIDER"] = "medical-rider";
  ProductType["OUTPATIENT"] = "outpatient";
  ProductType["GROUP_MEDICAL"] = "group-medical";
  ProductType["GROUP_MEDICAL_TAILOR_MADE"] = "group-medical-tailor-made";
  ProductType["LIFE"] = "life";
  ProductType["CRITICAL_ILLNESS"] = "critical-illness";
  ProductType["GROUP_VISION_CARE"] = "group-vision-care";
  ProductType["VISION_CARE"] = "vision-care";
  ProductType["GROUP_LIFE"] = "group-life";
  ProductType["GROUP_LIFE_TAILOR_MADE"] = "group-life-tailor-made";
  ProductType["PREVENTIVE_CARE"] = "preventive-care";
  ProductType["PARENT_MEDICAL"] = "parent-medical";
  ProductType["GROUP_MEDICAL_MIX_AND_MATCH"] = "group-medical-mix-and-match";
  ProductType["GROUP_LIFE_MIX_AND_MATCH"] = "group-life-mix-and-match";
  ProductType["TERM_LIFE_RIDER"] = "term-life-rider";
  ProductType["CRITICAL_ILLNESS_CHILDREN_GROWTH"] = "critical-illness-children-growth";
})(ProductType || (ProductType = {}));

export const DEFAULT_RANGE = {
  product: '',
  min_issue_age: 0,
  max_issue_age: 65,
  min_sum_assured: 200000,
  max_sum_assured: 1000000,
  create_date: ''
};